import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateProvider } from 'angular-ui-router';

angular.module('flowingly.runner.publicmap').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider): void {
  $stateProvider.state('app.publicmap', {
    url: '/map/{id}',
    params: {
      title: 'Map'
    },
    controller: 'runnerPublicMapController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.publicmap/runner.publicmap.tmpl.html',
    resolve: {
      settingsLoaded: [
        '$q',
        'APP_CONFIG',
        'sessionService',
        function (
          $q: angular.IQService,
          APP_CONFIG: SharedAngular.APP_CONFIG,
          sessionService: SharedAngular.SessionService
        ) {
          const user = sessionService.getUser();
          if (user) {
            return APP_CONFIG.ready;
          }
          return $q.resolve();
        }
      ]
    }
  });
}
